import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import DocumentViewer from "components/bid_module/DocumentViewer";
import { ScorecardSource } from "components/bid_module/types";
import Button from "components/ui/button/Button";
import Drawer from "components/ui/drawer/Drawer";
import { FileViewerContextProvider } from "lib/core_components/FileViewer";
import UIcon from "lib/icons/untitled_ui/UIcon";
import { useGetCustomerDocumentUrl } from "../../lib/hooks/api/customer_documents/useDownloadCustomerDocument";

type Props = {
  source: ScorecardSource;
  isOpen: boolean;
  onClose: () => void;
};

export function CustomerDocumentDrawer({ source, onClose, isOpen }: Props) {
  const { data: documentUrl } = useGetCustomerDocumentUrl(source.documentId, {
    enabled: !!source.documentId,
  });

  // TODO: This should be done in the backend
  let fileExtension = source.fileName?.split(".").pop() || "";
  if (["odt", "odp", "ods"].includes(fileExtension)) {
    fileExtension = "pdf";
  }

  return (
    <Drawer
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
      width={1200}
    >
      <FileViewerContextProvider key={`${documentUrl}-${+true}`}>
        <PreviewWrapper>
          <Controls>
            <Button
              buttonType="secondary"
              title="Close"
              icon="chevronRightDouble"
              onClick={onClose}
            />
          </Controls>
          {documentUrl ? (
            <DocumentViewer
              documentUrl={documentUrl}
              fileExtension={fileExtension}
              source={source}
              open={true}
            />
          ) : (
            <Flex alignItems="center" justifyContent="center" width="100%">
              <UIcon icon="spinner" size={32} />
            </Flex>
          )}
        </PreviewWrapper>
      </FileViewerContextProvider>
    </Drawer>
  );
}

const PreviewWrapper = styled(Flex)({
  paddingRight: 16,
});

const Controls = styled(Flex)(({ theme }) => ({
  flexDirection: "column",
  alignItems: "center",
  borderRight: `1px solid ${theme.colors.sysBorderDecorative}`,
  height: "100vh",
  padding: 16,
}));
